import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from './alert';
import { removeAlert } from '../../actions/alerts';
import './styles.scss';

/*
  TODO: This is to provide distinct keys for each alert.
  If we pass alert ids, we wouldn't need to create a hash.
 */
const hashCode = (s) => {
  return s.split('').reduce((a, b) => {
    const hashBits = ((a << 5) - a) + b.charCodeAt(0);
    return hashBits & hashBits;
  }, 0);
};

const propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string,
    level: PropTypes.string,
  })),
  onRemoveAlert: PropTypes.func,
};

const defaultProps = {
  alerts: [],
  onRemoveAlert: _.noop
};

export class AlertsView extends React.Component {

  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }

  onClose(index) {
    return () => {
      const { alerts, onRemoveAlert } = this.props;
      const closedAlert = alerts[index];
      onRemoveAlert(closedAlert);
    }
  }

  render() {
    const { alerts } = this.props;
    const onClose = this.onClose;
    if (!alerts || alerts.length === 0) return null;
    return (
      <div>
        {alerts.filter((alert) => {
          return alert && typeof alert === 'object' && !_.isEmpty(alert.message);
        }).map((alert, index) => {
          return (
            <Alert
              key={hashCode(alert.message)}
              message={alert.message}
              level={alert.level}
              onClose={onClose(index)}
            />);
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alerts: state.alerts.data,
    updatingAlerts: state.alerts.updatingAlerts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRemoveAlert: alert => dispatch(removeAlert(alert)),
  };
}

AlertsView.propTypes = propTypes;
AlertsView.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(AlertsView);
